import React, { useEffect, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";

interface IPageScrollLocationState {
    noScrollTop: boolean;
}

const ControlledPageScroll: React.FC<{ className?: string; }> = ({ children, className }) => {
    const location = useLocation<IPageScrollLocationState>()
    const history = useHistory()

    const wrapperElement = useRef<HTMLDivElement>(null);

    useEffect(() => {
        let isNavigatingBackwards = history.action === "POP";
        if (!isNavigatingBackwards && location.state?.noScrollTop !== true) {
            wrapperElement.current && window.scrollTo(0, 0);
        }

    }, [location, history]);

    return (
        <div ref={wrapperElement} className={className}>  {children} </div>
    );
};


export default ControlledPageScroll;
